import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../firebase'

function CallRating({ roomId }) {
  const navigate = useNavigate()
  const [rating, setRating] = useState(0)
  const [feedback, setFeedback] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const submitRating = () => {
    logEvent(analytics, 'call_rating', {
      rating,
      feedback: feedback.trim() || undefined,
      room_id: roomId
    })
    setSubmitted(true)
    setTimeout(() => navigate('/'), 1500)
  }

  if (submitted) {
    return (
      <div className="call-rating">
        <p className="rating-thanks">Thanks for your feedback!</p>
      </div>
    )
  }

  return (
    <div className="call-rating">
      <p>How did the call go? </p>
      <div className="rating-smiles">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            className={`smile-btn ${rating === n ? 'selected' : ''}`}
            onClick={() => setRating(n)}
          >
            {['😞', '😕', '😐', '🙂', '😄'][n - 1]}
          </button>
        ))}
      </div>
      <textarea
        className="rating-feedback"
        placeholder="Help us make your next call even better. Share any issues or suggestions."
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        rows={3}
      />
      <div className="rating-actions">
        <button className="rating-submit" onClick={submitRating} disabled={!rating}>
          Submit
        </button>
        <button className="rating-skip" onClick={() => navigate('/')}>
          Skip
        </button>
      </div>
    </div>
  )
}

export default CallRating
